'use strict';

angular.module('shop').controller('AccountController', function ($rootScope, $scope, $location, $state, ShopService) {

	// Return to checkout if empty cart
	$scope.cart = ShopService.getCart();
	if (!$scope.cart || !$scope.cart.cartArticles || $scope.cart.cartArticles.length === 0) {
		$state.go('checkout');
	}

	$scope.validEmail = false;

	var params = $location.search();

	if (params.signuperror === 'duplicate' || params.signuperror === 'Fel, epost finns redan.') {
		$state.go('duplicate');
	} else {
		$scope.signupError = params.signuperror;
	}

	if (params.formerror) {
		$scope.formError = params.formerror;
	}

	$scope.checkEmail = function(email) {
		var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

		if (regex.test(email)) {
			$scope.validEmail = true;
		} else {
			$scope.validEmail = false;
		}
	};

});
